import { brandColors, brandGradients, statusColors, statusSoftColors, surfaceColors } from '../tokens/colors';

/** Resolved semantic palette for dark mode — see `light.ts` for the full explanation. */
export const darkTheme = {
  mode: 'dark' as const,
  primary: brandColors.primary,
  secondary: brandColors.secondary,
  accent: brandColors.accent,
  status: statusColors,
  statusSoft: statusSoftColors.dark,
  gradients: brandGradients,
  surface: surfaceColors.dark,
};
